import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  paymentMethod: Yup.string().required('Payment method required'),
  amount: Yup.number().required('Amount to bill required').nullable(),
  billType: Yup.string().required('Bill type required'),
  internalDescription: Yup.string().required('Description required')
});

export const remainingBalanceValidationSchema = Yup.object().shape({
  paymentMethod: Yup.string().required('Payment method required'),
  internalDescription: Yup.string().required('Description required')
});

// Internal staff charging a policy's agency sweep account for an agent must name that agent (#36683).
export const staffChargeValidationSchema = (sweepPaymentMethodIds) =>
  validationSchema.shape({
    requestedBy: Yup.string().when('paymentMethod', {
      is: (paymentMethod) => sweepPaymentMethodIds.has(paymentMethod),
      then: Yup.string().trim().required('Requested by (agent) required')
    })
  });
